export default "__VITE_ASSET__kXYa4YZ2__"